<template lang='pug'>
  #app    
    
    flash-message#theFlash(
      transitionName="fade"
    )
    router-view
    .loadingOverlay(v-show="loadingOverlay == true")
      Spinner
</template>
<script>
// @ is an alias to /src
import '@/assets/scss/main.scss'
import Spinner from 'vue-simple-spinner';
require('vue-flash-message/dist/vue-flash-message.min.css');
import { mapActions, mapState } from "vuex";

export default {
  name: 'App',
  components:{
    Spinner
  },
  methods:{
      ...mapActions(['checkLogin',]),      
    },
  computed:{
    ...mapState(['loadingOverlay']),
  },
  metaInfo: {
    title: 'Return Postage',
    titleTemplate: '%s - Return Postage'
  },
  created(){
    
  }
}
</script>
<style lang="scss">
  .loadingOverlay{
    position:fixed;
    top:0;
    left:0;
    z-index: 11;
    background-color: rgba(0,0,0,.5);
    width:100vw;
    height:100vh;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  #theFlash{
    position: fixed;
    top:20px;
    right:20px;
    max-height: 400px;
    width: 260px;
    -webkit-perspective: 400px;
    perspective: 400px;
    z-index:99;
    
  }
  i.fas.fa-fw{
    font-size:20px;
  }
  // @keyframes{
  //   from{height:0;}
  //   to{height:100%;}
  // }
  
</style>
